/* bf26y-perks (13 Oct 2026, r8): ONE offer pill per card, top right of the card image, plus the card's own info note below it.
   The offer pill is the NEXT offer for the live cart, from the ladder config (window.bf26gLadder.config(): 3 free wash bag, 4 20%, 5 20% + free shipping, 6 25%, 7 25% + free mystery gift, 8+ 30%) and N = ladder item count in the cart now (r13: info.count, which includes the free wash bag, so the pills agree with the ladder bar).
   One function, offer(N, card), one wording family, used by every card type (collection cards, search, builder / sets cards, accessories, homepage tile, cart recs):
     card adds 1 piece and that reaches a tier   -> "Add 1 more to unlock X"
     card adds several pieces and reaches a tier -> "Add to unlock X"   (X = what the cart would newly get after the add: best % + any newly unlocked perks)
     bag-including set (RKKN Set, glove 3-packs), cart under 3 pieces, no wash bag in the cart yet, outcome is only the bag -> "+free wash bag" (it truly adds the bag)
     r54 (15 Oct 2026): the wash bag is always written "+free wash bag" (DESIGN 9.6), e.g. "Add 1 more to unlock +free wash bag".
     nothing new reachable (or cart already at the top tier) -> no offer pill.
   Card piece counts K: singles 1 (any ladder product), RKKN Set 5 (+ bag), Starter Set 2, glove 3-packs 3 (+ bag).
   The info note (builder cards, e.g. "2 clips. Counts as 1 item.") moves into the stack under the offer pill; notes that say "free" keep the offer colour. Also hides the SAVE badge on cards.
   Event driven (ladder onUpdate, section load, facet change, clicks), no polling, no document-wide observer. Rollback: backups -bak-20261013-r8 and -bak-20261013-r13. */
(function () {
  'use strict';
  if (window.BF26Y_PERKS) return;
  window.BF26Y_PERKS = 1;
  var SETS = {
    'rkkn-set': { k: 5, bag: 1 }, 'starter-set': { k: 2, bag: 0 },
    'softgrip-pilates-gloves-power-set': { k: 3, bag: 1 }, 'softgrip-pilates-gloves-blue-set': { k: 3, bag: 1 }, 'softgrip-pilates-gloves-queen-set': { k: 3, bag: 1 }
  };
  var GLOVE3 = { 'softgrip-pilates-gloves-power-set': 1, 'softgrip-pilates-gloves-blue-set': 1, 'softgrip-pilates-gloves-queen-set': 1 };
  var E = null, piece = null, items = [], tm = 0;
  var BAG = '+free wash bag';   /* r54: the one wash bag wording on every card tag (DESIGN 9.6) */

  function loadPieces() {
    piece = {};
    try { JSON.parse(document.getElementById('bf26g-ladder-pieces-data').textContent || '[]').forEach(function (p) { piece[p.handle] = 1; }); } catch (e) {}
  }
  function low(s) { return String(s || '').replace(/^\s+|\s+$/g, '').toLowerCase(); }
  function cardInfo(h) { return SETS[h] || (piece && piece[h] ? { k: 1, bag: 0 } : null); }
  function handleOf(root) {
    var a = root.querySelector('a[href*="/products/"]'), m = a && /\/products\/([^\/?#]+)/.exec(a.getAttribute('href') || '');
    return m ? m[1] : '';
  }

  /* THE offer function */
  function offer(N, c, bagIn) {
    if (!E || !c || !c.k || N == null) return '';
    var C = E.config(), M = N + c.k, hit = C.thresholds.filter(function (t) { return t > N && t <= M; });
    if (!hit.length) return '';
    var top = Math.max.apply(null, hit), bag = low(C.perks[C.start]);
    if (c.bag && !bagIn && N < C.start && top <= C.start) return BAG; /* r54: exactly "+free wash bag" (DESIGN 9.6) */
    var parts = [];
    if (E.pctFor(M) > E.pctFor(N)) parts.push(E.pctLabel(E.pctFor(M)) + ' off');
    Object.keys(C.perks).map(Number).sort(function (a, b) { return a - b; }).forEach(function (t) {
      if (hit.indexOf(t) < 0) return;
      var p = low(C.perks[t]);
      if (p === bag && (c.bag || bagIn)) return;   /* the set itself brings the bag, or the cart already has it */
      parts.push(p === bag ? BAG : p);
    });
    if (!parts.length) return '';
    var x = parts.reduce(function (s, p) { return s ? s + (p.charAt(0) === '+' ? ' ' : ' + ') + p : p; }, ''); /* r55 FX4: "20% off +free wash bag", never "+ +free" */
    if (parts.length === 1 && /^free mystery gift$/.test(x)) x = 'a ' + x;
    return (c.k === 1 ? 'Add 1 more' : 'Add') + ' to unlock ' + x;
  }

  function paint() {
    if (!E) return;
    var info = E.getInfo && E.getInfo(), N = info && typeof info.count === 'number' ? info.count : (info && typeof info.pieces === 'number' ? info.pieces : null), stale = false, bagIn = false;
    /* live cart: a wash bag line in the cart means the bag perk is already there. Glove 3-pack set lines are counted as pieces by the ladder engine itself (13 Oct r11), so N is not adjusted here any more */
    var cart = E.getCart && E.getCart();
    if (cart && cart.items) cart.items.forEach(function (l) { if (l.handle === 'wash-bag') bagIn = true; });
    for (var i = items.length - 1; i >= 0; i--) {
      var it = items[i];
      if (!it.box.isConnected) {   /* a builder re-rendered the card: forget it, the next scan adds it again */
        if (it.card && it.card.isConnected) { it.card.removeAttribute('data-bf26y'); it.card.classList.remove('bf26y-n'); stale = true; }
        items.splice(i, 1);
        continue;
      }
      if (it.fixed) continue;
      if (N == null) continue; /* r55 FX4: the cart is not read yet: keep the server-printed pill (snippets/rk-card-perks.liquid) as it is */
      var txt = offer(N, it.c, bagIn);
      it.box.textContent = txt;
      it.box.hidden = !txt;
    }
    if (stale) setTimeout(scan, 0);
  }

  function stack(media) {
    var st = null, i;
    for (i = 0; i < media.children.length; i++) if (media.children[i].classList.contains('bf26y-stack')) st = media.children[i];
    if (!st) {
      st = document.createElement('div');
      st.className = 'bf26y-stack';
      media.classList.add('bf26y-host');
      media.appendChild(st);
    }
    return st;
  }
  function pill(st, cls, txt) {
    var s = document.createElement('span');
    s.className = cls;
    if (txt != null) s.textContent = txt;
    st.appendChild(s);
    return s;
  }
  function make(card, c, media) {
    if (!media || !c) return;
    var st = stack(media);
    /* r55 FX4 (Q3-05): the pill is printed by Liquid (snippets/rk-card-perks.liquid); adopt it so a cart change updates it, never build a second one */
    var ex = st.querySelector('.bf26y-pill');
    if (ex) { if (!items.some(function (i) { return i.box === ex; })) items.push({ box: ex, c: c, card: card }); return; }
    var p = pill(st, 'bf26y-pill', '');
    p.hidden = true;
    items.push({ box: p, c: c, card: card });
  }

  /* the card's own short description (builder cards): out from under the card, into the stack, below the offer pill */
  function moveNote(c) {
    var n = c.querySelector('.bb-card__note'), media = c.querySelector('.bb-card__media'), t = n && n.textContent.replace(/\s+/g, ' ').replace(/^ | $/g, '');
    if (!t || !media || c.classList.contains('bs-card')) return;
    c.classList.add('bf26y-n');
    if (media.querySelector('.bf26y-stack > .bf26y-note')) return; /* r55 FX4: already printed by Liquid (snippets/rk-card-perks.liquid) */
    items.push({ box: pill(stack(media), 'bf26y-note' + (/\bfree\b/i.test(t) ? ' is-offer' : ''), t), card: c, fixed: 1 });
  }

  function scan() {
    if (!E) return;
    if (!piece) loadPieces();
    var cards = document.querySelectorAll('.card-wrapper:not([data-bf26y]), .bb-card[data-handle]:not([data-bf26y]), .acc-card[data-product]:not([data-bf26y])');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i], isBB = c.classList.contains('bb-card'), isAcc = c.classList.contains('acc-card');
      c.setAttribute('data-bf26y', '1');
      Array.prototype.forEach.call(c.querySelectorAll('.badge'), function (b) { if (/^\s*save\b/i.test(b.textContent)) b.style.display = 'none'; });
      var h = isBB ? c.getAttribute('data-handle') : isAcc ? c.getAttribute('data-product') : handleOf(c);
      var media = isBB ? c.querySelector('.bb-card__media') : isAcc ? c.querySelector('.acc-card__media') : c.querySelector('.card__inner');
      if (!isBB && !isAcc) { var tl = c.querySelector('.card__heading a'); if (tl && /2-Pack (Small|Large)\s*$/.test(tl.textContent)) tl.textContent = tl.textContent.replace(/\s+/g, ' ').replace(/^ | $/g, '').replace(/2-Pack (Small|Large)$/, '2-Pack, $1'); }
      if (isBB) moveNote(c);
      if (isBB && c.closest('[data-rk-nopill]')) continue; /* Phase 1 wash bag rewards: no offer pill on Bundle Builder cards (the ladder bar and reward tiles carry it) */
      make(c, cardInfo(h), media || c);
    }
    /* homepage "The RKKN Set" tile (Shop by area): same set, a plain multicolumn card */
    var tl2 = document.querySelectorAll('.multicolumn-card:not([data-bf26y]) a[href$="/pages/sets"]');
    for (var j = 0; j < tl2.length; j++) {
      var mc = tl2[j].closest('.multicolumn-card');
      if (!mc || !/R.KN Set/.test(mc.textContent || '')) continue;
      mc.setAttribute('data-bf26y', '1');
      make(mc, SETS['rkkn-set'], mc.querySelector('.multicolumn-card__image-wrapper') || mc);
    }
    paint();
  }

  function later() { clearTimeout(tm); tm = setTimeout(function () { scan(); setTimeout(scan, 900); }, 350); }

  function init() {
    var tries = 0;
    (function wait() {
      var L = window.bf26gLadder;
      if (L && L.onUpdate && L.config) {
        E = L;
        L.onUpdate(function () { scan(); paint(); });
        scan();
        return;
      }
      if (++tries < 40) setTimeout(wait, 250);
    })();
    window.addEventListener('load', paint);
    document.addEventListener('shopify:section:load', later);
    document.addEventListener('bf26:cart', function () { setTimeout(paint, 250); });
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('facet-filters-form, .facets, form[id*="Facet"]')) later(); }, true);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.facets a, .active-facets a, .pagination a, .bbu-qv-m, .bbu-qv-t, modal-opener, [data-bb-opt], .acc-chip')) later();
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
